@if (is_loading()) {
  <div class="matrix-state">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else if (error_message()) {
  <div class="matrix-state">
    <p>{{ error_message() }}</p>
  </div>
} @else {
  @if (view_model(); as view) {
    <div class="matrix-scroll">
      <table class="efficiency-matrix-table">
        <thead>
          <tr>
            <th class="sticky-corner sticky-tone"></th>
            <th class="sticky-general-col sticky-header-cell sticky-tone">General</th>
            @for (column of view.columns; track column.id) {
              <th class="sticky-header-cell sticky-tone">
                <div class="column-header">
                  <img [src]="column.logo_url" [alt]="column.name" class="column-logo" />
                  <span class="column-name" [matTooltip]="column.name">{{ column.name }}</span>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr class="general-row">
            <th class="sticky-row-label sticky-tone">
              <span class="row-label-text">General</span>
            </th>
            <td class="sticky-general-col sticky-tone">
              @if (view.global_general; as cell) {
                <span class="efficiency-pair" [matTooltip]="cell.tooltip">
                  <span class="efficiency-real" [style.color]="cell.color_css">{{ cell.real_label }}</span>
                  <span class="efficiency-separator">/</span>
                  <span class="efficiency-expected">{{ cell.expected_label }}</span>
                </span>
              }
            </td>
            @for (column of view.columns; track column.id) {
              <td class="sticky-tone">
                @if (column.general; as cell) {
                  <span class="efficiency-pair" [matTooltip]="cell.tooltip">
                    <span class="efficiency-real" [style.color]="cell.color_css">{{ cell.real_label }}</span>
                    <span class="efficiency-separator">/</span>
                    <span class="efficiency-expected">{{ cell.expected_label }}</span>
                  </span>
                }
              </td>
            }
          </tr>
          @for (row of view.rows; track row.id) {
            <tr>
              <th class="sticky-row-label sticky-tone">
                <div class="row-label">
                  <img [src]="row.informal_photo_url" [alt]="row.name" class="row-avatar" />
                  <img [src]="row.formal_photo_url" [alt]="row.name" class="row-avatar" />
                  <span class="row-label-text" [matTooltip]="row.name">{{ row.name }}</span>
                </div>
              </th>
              <td class="sticky-general-col sticky-tone">
                @if (row.general; as cell) {
                  <span class="efficiency-pair" [matTooltip]="cell.tooltip">
                    <span class="efficiency-real" [style.color]="cell.color_css">{{ cell.real_label }}</span>
                    <span class="efficiency-separator">/</span>
                    <span class="efficiency-expected">{{ cell.expected_label }}</span>
                  </span>
                }
              </td>
              @for (cell of row.cells; track $index) {
                <td>
                  <button type="button" class="cell-button" [matTooltip]="cell.tooltip" (click)="openCellDetail(cell)">
                    @if (cell.real_label && cell.expected_label) {
                      <span class="efficiency-pair">
                        <span class="efficiency-real" [style.color]="cell.color_css">{{ cell.real_label }}</span>
                        <span class="efficiency-separator">/</span>
                        <span class="efficiency-expected">{{ cell.expected_label }}</span>
                      </span>
                    } @else {
                      <span class="efficiency-empty">·</span>
                    }
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}
